import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { accountInitialize } from "store/accountActions";

import { staticData } from "managers/staticDataManager";

const About = (params) => {
  const dispatch = useDispatch();
  const { languages } = useSelector(state => state.staticData);
  const { channel } = useSelector(state => state.staticData);
  const account = useSelector(state => state.account);
  
  React.useEffect(() => {
    // console.log('About-React.useEffect-params?.match?.params: ', params?.match?.params);
    changeLanguageHandler(params?.match?.params?.language);
  }, [params?.match?.params])

  const changeLanguageHandler = (locale) => {
    if (!locale) return false;

    let language = languages.find(lang => lang.code.includes(locale));
    if (account?.language?.code === language?.code) return false;

    // console.log("account?.language?.code, language?.code: ", account?.language?.code, language?.code);
    if(account?.language?.code !== language?.code) {
      dispatch(accountInitialize({ language }));
      return true;
    }

    return false;
  }

  return (
    <main className="xxl container mb-4">
        <div dangerouslySetInnerHTML={{ __html: staticData.loadTerms(useSelector, `VW_PUBLIC_ABOUT_${channel.code}`) }} />
    </main>
)
}
export default About;